import axios from 'axios'

import { config } from '../../common/config'

export enum Section {
  FREE_ITEMS = 'free-items',
  FEATURED_ITEMS = 'featured-items',
  FEATURED_ITEMS_PAGE = 'featured-items-page',
  FEATURED_AUTHORS = 'featured-authors',
  CATEGORIES = 'categories',
  NEWEST_ITEMS = 'newest-items'
}

export const getBlobPath = (
  site: string,
  section: Section,
  category?: string
) => {
  const jsonFile = category ? `${category}.json` : 'index.json'
  let fullUrl = `${site}/${section}/${jsonFile}`

  if (section === Section.FREE_ITEMS) {
    fullUrl = `defaults/${section}.json`
  }

  if (
    [
      Section.FEATURED_ITEMS,
      Section.FEATURED_ITEMS_PAGE,
      Section.FEATURED_AUTHORS,
      Section.CATEGORIES
    ].includes(section)
  ) {
    fullUrl = `${site}/${section}.json`
  }

  return fullUrl
}

// https://s3.amazonaws.com/market-shopfront-staging-api-data-us-east-1/3docean/newest-items/index.json
export const getDataFromS3 = <T>(
  site: string,
  section: Section,
  category?: string
) => {
  const path = getBlobPath(site, section, category)
  return axios.get<T>(`${config.HOMEPAGE_JSON_BUCKET_URL}/${path}`)
}

// https://api-data.shopfront.envato.com/3docean/newest-items/index.json
export const getDataFromCloudfront = <T>(
  site: string,
  section: Section,
  category?: string
) => {
  const path = getBlobPath(site, section, category)
  return axios.get<T>(`${config.HOMEPAGE_JSON_CDN_URL}/${path}`)
}
